import popupContentComponent from './popupContent.component';

const popupContentModule = angular.module('app.common.ertPopupContent', [])
	.component('ertPopupContent', popupContentComponent)
	.name;

export default popupContentModule;
